module.exports = __webpack_public_path__ + "img/06.55029502.jpg";